export default "__VITE_ASSET__Cz37pvk9__"